import clienteHttp from "./ClienteHttps";
//import axios from 'axios';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

//axios.defaults.withCredentials = true;

export async function obtenerNotificacionesDeBD(usuarioId) {
    const respuesta = await clienteHttp.get(`/notificaciones`, {
        headers: { "usuario-id": usuarioId }
    });
    return respuesta.data;
}

export async function marcarComoLeidaEnBD(usuarioId, notificacionId) {
    const respuesta = await clienteHttp.patch(`/notificaciones/${notificacionId}/leida`, 
        {}, 
        { headers: { "usuario-id": usuarioId } }
    );
    return respuesta.data;
}